import Project from './Models/Project'
import Code from './Models/Code'
import Output from './Models/Output'

Vue.prototype.$models.$project = new Vue(Project)
Vue.prototype.$models.$code = new Vue(Code)
Vue.prototype.$models.$output = new Vue(Output)

Vue.component('projects-table', () => import(/* webpackChunkName: "projects-table" */ '@modulesPages/Site/Resources/assets/js/Tables/ProjectsTable'))
Vue.component('codes-table', () => import(/* webpackChunkName: "codes-table" */ '@modulesPages/Site/Resources/assets/js/Tables/CodesTable'))
Vue.component('outputs-table', () => import(/* webpackChunkName: "outputs-table" */ '@modulesPages/Site/Resources/assets/js/Tables/OutputsTable'))

Vue.component('projects-form', () => import(/* webpackChunkName: "projects-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Projects/ProjectsForm'))
Vue.component('codes-form', () => import(/* webpackChunkName: "codes-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Codes/CodesForm'))

Vue.component('print-code-button', () => import(/* webpackChunkName: "print-code-button" */ '@modulesPages/Site/Resources/assets/js/Components/PrintCodeButton'))
Vue.component('print-code-layout', () => import(/* webpackChunkName: "print-code-layout" */ '@modulesPages/Site/Resources/assets/js/Components/PrintCodeLayout'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Site\\Entities\\Project': 'Proyecto',
        'Modules\\Site\\Entities\\Code': 'Códigos',
        'Modules\\Site\\Entities\\Output': 'Impresión',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Site\\Entities\\Project': 'projects',
        'Modules\\Site\\Entities\\Code': 'codes',
        'Modules\\Site\\Entities\\Output': 'outputs',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'projects': 'Modules\\Site\\Entities\\Project',
        'codes': 'Modules\\Site\\Entities\\Code',
        'outputs': 'Modules\\Site\\Entities\\Output',
    }   
}
